module.exports = __webpack_public_path__ + "img/sentTrialLesson.8d87b496.png";